import {Controller} from '@hotwired/stimulus';


export default class extends Controller {

    static targets = ['current']

    connect() {
        this._scrollTo()
    }

    _scrollTo() {

        let currentItem = this.hasCurrentTarget ? this.currentTarget : this.element.lastElementChild

        let cLeft = this.element.getBoundingClientRect().left;
        let eLeft = currentItem.getBoundingClientRect().left;

        let distanceSquared = Math.pow(cLeft - eLeft, 2);
        let distance = Math.sqrt(distanceSquared);

        this.element.scrollTo({
            top: 0,
            left: distance
        });

        setTimeout(() => this.element.classList.add('show'), 1000)
    }

}